// 设置 rem 函数
function setRem () {
    var fontSize = 100;
    var elm = document.documentElement;
    elm.style.fontSize = fontSize * (elm.clientWidth/375) + 'px';
}
// 初始化
setRem();
// 改变窗口大小时重新设置 rem
window.onresize = function () {
    setRem()
}
